var _circle, _circle2, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecording = function SvgRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#000",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 24,
    fill: "#000",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 7,
    y: 7,
    fill: "#000",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.643 17.976a3.333 3.333 0 0 1 5.69 2.357V27a3.333 3.333 0 1 1-6.666 0v-6.667c0-.884.35-1.732.976-2.357m2.357.69a1.667 1.667 0 0 0-1.667 1.667V27a1.667 1.667 0 0 0 3.334 0v-6.667A1.667 1.667 0 0 0 27 18.667M21.167 24.5c.46 0 .833.373.833.833V27a5 5 0 1 0 10 0v-1.667a.833.833 0 0 1 1.667 0V27a6.67 6.67 0 0 1-5.834 6.614v1.72h2.5a.833.833 0 0 1 0 1.666h-6.666a.833.833 0 0 1 0-1.667h2.5v-1.719A6.67 6.67 0 0 1 20.333 27v-1.667c0-.46.373-.833.834-.833",
    clipRule: "evenodd"
  })));
};
export default SvgRecording;